
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiOwnShipAlternativeFilled as ObiOwnShipAlternativeFilledElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-own-ship-alternative-filled.js';
 
 
 

 
 export const ObiOwnShipAlternativeFilled = createComponent({
   react: React,
   tagName: 'obi-own-ship-alternative-filled',
   elementClass: ObiOwnShipAlternativeFilledElement,
   events: {
     
   }
  });
 
 